module.exports = __webpack_public_path__ + "static/media/30-4.332dc7ea.mp3";